var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status_text_main df ac jc cp"},[_c('div',{staticClass:"status_circle_box circle relative",class:'bg-' + _vm.type,style:({
      background: _vm.background,
      width: _vm.size + 'px',
      height: _vm.size + 'px',
    })},[_c('span',{staticClass:"absolute db circle"})]),_c('div',{staticClass:"status_text_box fz-12 m-l-10"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }